import { ReactNode } from "react";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import styles from "./TaskInfoModal.module.css";

type TaskInfoModalProps = {
  visible: boolean;
  onClose: () => void;
  title: string;
  heading: string;
  description: string;
  illustration?: ReactNode;
};

function TaskInfoModal({
  visible,
  onClose,
  title,
  heading,
  description,
  illustration,
}: TaskInfoModalProps) {
  return (
    <FixaModal visible={visible} handleCloseBtn={onClose}>
      <FixaSheets
        header={
          <FixaModalHeader
            title={title}
            titleId="task-info-modal"
            closeBtnClick={onClose}
          />
        }
        footer={null}
        fullSize
        labelledById="task-info-modal"
      >
        <FixaModalBody>
          <div className={styles["body"]}>
            {illustration}
            <FixaText textStyle="Heading.S" tagName="h3">
              {heading}
            </FixaText>
            <FixaText textStyle="Body.L" className={styles["description"]}>
              {description}
            </FixaText>
          </div>
        </FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
}

export default TaskInfoModal;
